// Minimal client for the backend's public endpoints. Everything here is
// unauthenticated — the XentriPay API key lives on the server only.

export const API_URL = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

async function request(path, options = {}) {
  if (!API_URL) throw new Error('Online booking is not configured.');
  let res;
  try {
    res = await fetch(`${API_URL}${path}`, {
      headers: { 'Content-Type': 'application/json' },
      ...options,
    });
  } catch {
    throw new Error('Could not reach the server. Check your connection and try again.');
  }
  const body = await res.json().catch(() => null);
  if (!res.ok) {
    const fieldErrors = body?.validationErrors ? Object.values(body.validationErrors) : [];
    const err = new Error(fieldErrors[0] || body?.message || `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return body?.data ?? body;
}

export function fetchOpenEvents() {
  return request('/api/public/events');
}

export function createReservation(payload) {
  return request('/api/public/reservations', { method: 'POST', body: JSON.stringify(payload) });
}

export function fetchReservationStatus(reference) {
  return request(`/api/public/reservations/${encodeURIComponent(reference)}`);
}

/** Accepts 07XXXXXXXX, 7XXXXXXXX, 2507XXXXXXXX or +250 7XX XXX XXX. */
export function isRwandanMobile(value) {
  const digits = String(value || '').replace(/\D/g, '');
  return /^(250|0)?7[2389]\d{7}$/.test(digits);
}

export function formatRWF(n) {
  return `${Math.round(Number(n) || 0).toLocaleString('en-US')} RWF`;
}
